export enum BcacheModes {
  WRITE_BACK = "writeback",
  WRITE_THROUGH = "writethrough",
  WRITE_AROUND = "writearound",
}

export enum MachineMeta {
  MODEL = "machine",
  PK = "system_id",
}
